import { create } from "./ndc.js";

const term = document.getElementById("term");

create(term);
